import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PlanningAPI(): BringozApi {

  return {
    base: `/planning`,
    infiniteScroll: {
      address: `/planning`,
      cmd: 'GET'
    },
    actions: {
      getVehicleResources: {
        address: 'resources/vehicles',
        cmd: 'GET',
        updateable: false
      },
      getAllocationResources: {
        address: 'resources/allocations',
        cmd: 'GET',
        updateable: false
      },
      getAgentScheduleResources: {
        address: 'resources/schedule',
        cmd: 'GET',
        updateable: false
      },
      getDepots: {
        address: 'depots',
        cmd: 'GET',
        updateable: false
      },
      createProjectWithOrders: {
        address: 'import/orders',
        cmd: 'PUT',
        updateable: false
      },
      createProjectWithFulfillments: {
        address: 'import/fulfillment',
        cmd: 'PUT',
        updateable: false
      },
      addOrdersToProject: {
        address: 'import/orders/{projectId}',
        cmd: 'POST',
        updateable: false
      },
      addServicesToProject: {
        address: 'import/services/{projectId}',
        cmd: 'POST',
        updateable: false
      },
      addAbortedServicesToProject: {
        address: 'import/services/aborted/{projectId}',
        cmd: 'POST',
        updateable: false
      },
      addStepsToProject: {
        address: 'import/fulfillmentSteps/{projectId}',
        cmd: 'POST',
        updateable: false
      },
      addFulfillmentToProject : {
        address: 'import/fulfillment/{projectId}',
        cmd: 'POST',
        updateable: false
      },
      getAllTemplates: {
        address: 'templates',
        cmd: 'GET',
        updateable: true
      },
      createTemplate: {
        address: 'templates',
        cmd: 'PUT',
        updateable: false
      },
      getTemplate: {
        address: 'templates/{id}',
        cmd: 'GET',
        updateable: true
      },
      getDraftAnalysis: {
        address: 'analysis/draft',
        cmd: 'GET',
        updateable: false
      },
      updateTemplate: {
        address: 'templates/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteTemplate: {
        address: 'templates/{id}',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      exportDraft: {
        address: 'export/draft',
        cmd: 'GET',
        updateable: true
      },
      exportDraftReport: {
        address: 'reports/plannedDraft',
        cmd: 'PUT',
        updateable: true
      },
      servicePlanning: {
        address: 'servicePlanning',
        cmd: 'PUT',
        updateable: true
      },
      getMonitoring: {
        address: 'monitoring',
        cmd: 'GET',
        updateable: true
      },
      editClusteringArea: {
        address: 'clusteringAreas/{clusteringAreaId}',
        cmd: 'POST',
        updateable: false
      },
      syncClusteringAreas: {
        address: 'clusteringAreas/syncClusteringAreas',
        cmd: 'POST',
        updateable: false
      },
      queryClusteringAreas: {
        address: 'clusteringAreas/query',
        cmd: 'GET',
        updateable: false
      },
      getClusteringAreasByIds: {
        address: 'clusteringAreas/byIds',
        cmd: 'GET',
        updateable: false
      },
      addClusteringAreaToTemplate: {
        address: 'templates/{id}/addArea',
        cmd: 'POST',
        updateable: false
      },
      removeClusteringAreaFromTemplate: {
        address: 'templates/{id}/removeClusteringArea',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.planning')
  .service('PlanningAPI', PlanningAPI);
